"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Column = _interopRequireDefault(require("../../layout/Column"));
var _Row = _interopRequireDefault(require("../../layout/Row"));
var _Image = _interopRequireDefault(require("../../atoms/Image"));
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _OrderItemBottom = _interopRequireDefault(require("./OrderItemBottom"));
var _OrderItemSpecs = _interopRequireDefault(require("./OrderItemSpecs"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  image: '',
  name: '',
  time: '',
  description: '',
  specs: [],
  price: {},
  fallbackImage: '',
  imageLoadingType: 'eager',
  imageComponent: 'img',
  className: ''
};
function OrderItem(props) {
  const {
    specs,
    price,
    name,
    label,
    image,
    time,
    onClick,
    description,
    fallbackImage,
    imageLoadingType,
    containerStyles,
    imageComponent,
    className
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  return /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 5,
    onClick: onClick,
    styles: cssContainerStyles(containerStyles),
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledLabel, {
    type: "helper",
    numberOfLines: 1,
    weight: 700,
    size: 10,
    children: label,
    itemProp: "gtin13",
    show: (label === null || label === void 0 ? void 0 : label.length) > 0
  }), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    itemProp: "image",
    content: image
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: image,
    fit: "cover",
    loading: imageLoadingType,
    width: "100%",
    height: "100%",
    fallback: fallbackImage,
    imageComponent: imageComponent,
    alt: name
  })), /*#__PURE__*/_react.default.createElement(_Column.default, {
    align: "space-between",
    gap: 0,
    flex: 1
  }, /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 0
  }, time ? /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 0,
    align: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "title-3",
    numberOfLines: 1,
    weight: 700,
    size: 16,
    children: name,
    styles: cssTitleStyles
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "description",
    size: 12,
    children: time
  })) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "title-3",
    numberOfLines: 1,
    weight: 700,
    size: 16,
    children: name,
    styles: cssTitleStyles
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "description",
    numberOfLines: 2,
    size: 12,
    children: description,
    styles: cssDescriptionStyles
  })), /*#__PURE__*/_react.default.createElement(_OrderItemSpecs.default, {
    specs: specs,
    price: price
  }))));
}
const cssContainerStyles = extraStyles => (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  ", "\n"])), extraStyles);
const Content = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 7px;\n\n  @media screen and (min-width: 768px) {\n    gap: 10px;\n  }\n"])));
const StyledLabel = (0, _styled.default)(_Typography.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n\n  @media screen and (min-width: 768px) {\n    font-size: 14px;\n  }\n"])), _ref => {
  let {
    show
  } = _ref;
  return !show && "\n      position: absolute;\n      height: 0px;\n      opacity: 0;\n      overflow 0;\n      padding: 0;\n      pointer-events: none;\n  ";
});
const cssTitleStyles = (0, _react2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    font-size: 22px;\n  }\n"])));
const cssDescriptionStyles = (0, _react2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    font-size: 18px;\n    -webkit-line-clamp: 1;\n    line-height: normal;\n  }\n"])));
const ImageContainer = _styled.default.figure(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 70px;\n  height: 70px;\n  background-color: ", ";\n  border-radius: 10px;\n\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n\n  img[data-image-is-fallback='true'] {\n    width: 40px;\n    height: 40px;\n    margin: auto;\n  }\n\n  @media screen and (min-width: 768px) {\n    width: 80px;\n    height: 80px;\n\n    img[data-image-is-fallback='true'] {\n      width: 50px;\n      height: 50px;\n    }\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.NEUTRAL.SIDE;
});
OrderItem.OrderItemBottom = _OrderItemBottom.default;
OrderItem.Skeleton = _Skeleton.default;
var _default = exports.default = OrderItem;